import { createAction } from 'redux-promise-middleware-actions';

export const types = {
  SET_ONLINE_STATUS: 'SET_ONLINE_STATUS',
  SET_INSTALLED: 'SET_INSTALLED',
  SET_SHOW_INSTALL_PROMPT: 'SET_SHOW_INSTALL_PROMPT',
  SET_UPDATE_AVAILABLE: 'SET_UPDATE_AVAILABLE',
  SET_DEFERRED_PROMPT: 'SET_DEFERRED_PROMPT'
};

export const setOnlineStatus = createAction(types.SET_ONLINE_STATUS, (isOnline) => isOnline);

export const setInstalled = createAction(types.SET_INSTALLED, (isInstalled) => isInstalled);

export const setShowInstallPrompt = createAction(types.SET_SHOW_INSTALL_PROMPT, (show) => show);

export const setUpdateAvailable = createAction(types.SET_UPDATE_AVAILABLE, (available) => available);

export const setDeferredPrompt = createAction(types.SET_DEFERRED_PROMPT, (prompt) => prompt);